import util from '@/api/util'
export function baseurl () {
  return util.apiUrl()
}
export function yqfkurl () {
  return util.apiUrl()==='https://xmjyj.topeti.com' ? 'https://yqfk.xmedu.cn/' : util.apiUrl()
}